import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Carousel } from "react-bootstrap";
import "./style.css";

import quarto1 from "../../assets/Fotos Hotel/casal.jpg";
import quarto2 from "../../assets/Fotos Hotel/duplo.jpg";
import quarto3 from "../../assets/Fotos Hotel/solteiro.jpg";
import Apartamentos from "./funcaoAp.jsx";

const quartos = [
  {
    id: 1,
    titulo: "Quarto casal",
    descricao: "Ideal para casais — cama de casal, ar-condicionado e TV.",
    imagem: quarto1,
  },
  {
    id: 2,
    titulo: "Quarto duplo",
    descricao: "Duas camas de solteiro e todo o conforto para dois hóspedes.",
    imagem: quarto2,
  },
  {
    id: 3,
    titulo: "Quarto solteiro",
    descricao: "Compacto e completo — perfeito para viajantes e estadias rápidas.",
    imagem: quarto3,
  },
];

function Acomodacoes() {
  return (
    <>
      <header className="acomodacoes-hero">
        <div className="acomodacoes-hero__inner container text-center">
          <p className="section-eyebrow mb-2" data-aos="fade-down">
            Hospedagem
          </p>
          <h1 className="acomodacoes-hero__title text-white mb-3" data-aos="fade-up">
            Acomodações
          </h1>
          <p className="acomodacoes-hero__lead text-white-50 mx-auto mb-0" data-aos="fade-up" data-aos-delay={80}>
            Quartos pensados para o seu descanso, com café da manhã e atendimento atencioso.
          </p>
        </div>
      </header>

      <Container className="acomodacoes-page pb-5">
        <Row className="pt-4 g-4">
          {quartos.map((quarto, i) => (
            <Col key={quarto.id} md={4} sm={12} data-aos="fade-up" data-aos-delay={i * 90}>
              <Card className="card-quarto h-100 border-0 overflow-hidden">
                <div className="card-quarto__img-wrap">
                  <Card.Img className="card-quarto__img" variant="top" src={quarto.imagem} alt={quarto.titulo} />
                </div>
                <Card.Body className="d-flex flex-column">
                  <Card.Title className="font-display h5 mb-2">{quarto.titulo}</Card.Title>
                  <Card.Text className="text-muted small flex-grow-1">{quarto.descricao}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        <div data-aos="fade-up">
          <Apartamentos />
        </div>

        <section className="mt-5 pt-4">
          <header className="mb-4 text-center" data-aos="fade-up">
            <p className="section-eyebrow">Incluso</p>
            <h2 className="section-heading text-center d-inline-block">Café da manhã</h2>
            <p className="text-muted mx-auto mt-2" style={{ maxWidth: "28rem" }}>
              Comece o dia com um buffet variado no nosso espaço de refeições.
            </p>
          </header>
          <Row>
            <Col md={12}>
              <div className="rounded-4 overflow-hidden hotel-carousel-wrap shadow-sm">
                <Carousel controls indicators interval={8000} className="hotel-carousel">
                  {[
                    "https://www.google.com/maps/embed?pb=!4v1753155624956!6m8!1m7!1sCAoSHENJQUJJaEFEeWRFUjJTUC1NV2Y2VnVnQUNEekc.!2m2!1d-25.40649259814523!2d-52.41347302568855!3f12.4907660612987!4f-11.58638473611208!5f0.7820865974627469",
                    "https://www.google.com/maps/embed?pb=!4v1753155688083!6m8!1m7!1sCAoSHENJQUJJaEFEeWNLejZoTFNPbWY2VnZjQUJ1SEw.!2m2!1d-25.40649259814523!2d-52.41347302568855!3f263.8392524743679!4f-3.5617295299504406!5f0.7820865974627469",
                    "https://www.google.com/maps/embed?pb=!4v1753155723360!6m8!1m7!1sCAoSHENJQUJJaEFEeWRFUjJTUC1NV2Y2VndjQURONXY.!2m2!1d-25.40649259814523!2d-52.41347302568855!3f336.60031271795367!4f-12.596731316880806!5f0.7820865974627469",
                  ].map((src, idx) => (
                    <Carousel.Item key={src}>
                      <div className="iframe-wrapper">
                        <iframe src={src} title={`Café da manhã ${idx + 1}`} allowFullScreen loading="lazy" />
                      </div>
                    </Carousel.Item>
                  ))}
                </Carousel>
              </div>
            </Col>
          </Row>
        </section>
      </Container>
    </>
  );
}

export default Acomodacoes;
